<template>
  <div class="page-root">
    <div class="d-flex align-center justify-space-between">
      <h1><span class="font-weight-bold">병원</span></h1>
      <v-chip color="#fff3e0" text-color="#e8743b" class="font-weight-bold">🥕 {{ currencyBalance.toLocaleString() }}</v-chip>
    </div>
    <p class="text-caption grey--text mb-2">펫의 건강을 살피고 치료해요 🏥</p>

    <v-tabs v-model="tab" class="mb-4" color="#4a9e8f" slider-color="#4a9e8f">
      <v-tab>🔬 검사</v-tab>
      <v-tab>💊 치료</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- 검사 탭 -->
      <v-tab-item>
        <div class="hp-grid">
          <v-card v-for="item in exams" :key="item.name" class="hp-card" outlined>
            <div class="hp-card__emoji">{{ item.emoji }}</div>
            <div class="hp-card__name">{{ item.name }}</div>
            <div class="hp-card__desc">{{ item.desc }}</div>
            <v-btn v-if="item.to" class="hp-card__btn" rounded depressed color="#4a9e8f" dark :to="item.to">
              검사하기
            </v-btn>
            <v-btn v-else class="hp-card__btn" rounded depressed disabled>준비중</v-btn>
          </v-card>
        </div>
      </v-tab-item>

      <!-- 치료 탭 -->
      <v-tab-item>
        <div class="hp-grid">
          <v-card v-for="item in treatments" :key="item.name" class="hp-card" outlined>
            <div class="hp-card__emoji">{{ item.emoji }}</div>
            <div class="hp-card__name">{{ item.name }}</div>
            <div class="hp-card__desc">{{ item.desc }}</div>
            <v-btn class="hp-card__btn" rounded depressed disabled>준비중</v-btn>
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <p class="text-caption grey--text mt-6">※ 병원 기능은 준비 중입니다.</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HospitalPage",
  data() {
    return {
      tab: Number(this.$route.query.tab) || 0, // 탭 상태를 쿼리에서 복원(뒤로가기 유지)
      // 검사: 펫 상태 진단. to가 있으면 해당 검사 페이지로 이동(활성), 없으면 준비중.
      // (선호도 검사 외 나머지는 추후 구현 — 일단 비활성/주석)
      exams: [
        { emoji: "😋", name: "선호도 검사", desc: "좋아하는 음식을 알아내요", to: "/pet/hospital/favorite" },
        // { emoji: "🩺", name: "종합검진", desc: "전체 컨디션을 한 번에 진단" },
        // { emoji: "🍖", name: "영양검사", desc: "배고픔·식습관 상태 확인" },
        // { emoji: "⚡", name: "체력검사", desc: "에너지·피로도 측정" },
        // { emoji: "💗", name: "기분검사", desc: "기분(mood) 상태 진단" },
      ],
      // 치료: 상태 회복 (회복주사 외 나머지는 추후 구현 — 일단 주석)
      treatments: [
        { emoji: "💉", name: "회복주사", desc: "컨디션 빠른 회복" },
        // { emoji: "💊", name: "감기약", desc: "아픈 상태(SICK) 회복" },
        // { emoji: "🩹", name: "붕대", desc: "가벼운 상처 케어" },
        // { emoji: "🌿", name: "영양제", desc: "꾸준한 컨디션 보강" },
      ],
    };
  },
  computed: {
    ...mapState(["currencyBalance"]),
  },
  watch: {
    // 탭 전환 → 쿼리 동기화(뒤로가기 시 이전 탭 복원)
    tab(n) {
      this.$router.replace({ query: { ...this.$route.query, tab: String(n) } }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.page-root {
  padding: 24px 28px;
}
.hp-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
  padding-top: 4px;
}
.hp-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 22px 16px 18px;
  border-radius: 14px;
}
.hp-card__emoji {
  font-size: 44px;
}
.hp-card__name {
  font-size: 15px;
  font-weight: 700;
  color: #2a2540;
}
.hp-card__desc {
  font-size: 12px;
  color: #8a8699;
  text-align: center;
  min-height: 32px;
}
.hp-card__btn {
  margin-top: 6px;
  width: 100%;
  font-weight: 700 !important;
}
</style>
